//@flow
import React, {useState} from 'react';
import {makeStyles, Typography, MenuItem} from '@material-ui/core';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import CustomSelect from '../../../../../elements/CustomSelect/CustomSelect';
import {MULTICHAT_FUNNEL_COLORS} from '../../constants';
import {
  useMultichatFunnelsStageActions,
  useCurrentMultichatFunnelActions,
} from '../../utils';

import type {
  CreateMultichatFunnelStage,
  MultichatFunnelStage,
} from '../../../../../entities';
import InlineLoader from '../../../../../elements/LoadingSpinner/InlineLoader';
import {useAlert} from '../../../../../elements/Alert/AlertContext';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    alignItems: 'center',
    padding: '1rem',
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
  },
  inputContainer: {
    display: 'flex',
    gap: '.5rem',
    width: '100%',
  },
  label: {
    fontSize: 14,
  },
  loader: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    zIndex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
}));

type Props = {
  open: boolean,
  onClose: () => void,
  stage?: MultichatFunnelStage,
};

const FUNNEL_NAME_MAX_LENGTH = 20;

export default function FunnelLaneFormModal(props: Props) {
  const {open, onClose, stage} = props;

  const classes = useStyles();
  const {addLane} = useCurrentMultichatFunnelActions();

  const {showAlert} = useAlert();

  const {editFunnelStage, loading} = useMultichatFunnelsStageActions();

  const [funnelName, setFunnelName] = useState<string>(
    stage ? stage.label : ''
  );
  const [funnelColor, setFunnelColor] = useState<string>(
    stage ? stage.color : MULTICHAT_FUNNEL_COLORS[0]
  );

  const handleClose = () => {
    onClose();
    setFunnelName('');
    setFunnelColor(MULTICHAT_FUNNEL_COLORS[0]);
  };

  const crateStage = async () => {
    const stage: CreateMultichatFunnelStage = {
      color: funnelColor,
      label: funnelName,
    };

    try {
      addLane(stage);
    } catch (error) {
      showAlert('Error al crear la lista', {
        type: 'error',
      });
    }
  };

  const editStage = async () => {
    if (!stage) return;
    const newStage: CreateMultichatFunnelStage = {
      color: funnelColor,
      label: funnelName,
    };

    await editFunnelStage(stage.id, newStage).catch(() => {
      showAlert('Error al editar la lista', {
        type: 'error',
      });
    });
  };

  const handleSubmit = async () => {
    if (!funnelName) return;

    if (stage) {
      await editStage();
    } else {
      await crateStage();
    }

    handleClose();
  };

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.container}>
        {loading && (
          <div className={classes.loader}>
            <InlineLoader />
          </div>
        )}
        <Typography className={classes.title}>
          {stage ? 'Editar lista' : 'Crear nueva lista'}
        </Typography>

        <div className={classes.inputContainer}>
          <CustomSelect
            label="color"
            value={funnelColor}
            onChange={e => setFunnelColor(e.target.value)}
          >
            {MULTICHAT_FUNNEL_COLORS.map(color => (
              <MenuItem value={color} key={color}>
                <div
                  style={{
                    backgroundColor: color,
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                  }}
                ></div>
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomTextField
            label="Nombre de la lista"
            value={funnelName}
            required
            onChange={e => {
              const value = e.target.value;
              if (value.length <= FUNNEL_NAME_MAX_LENGTH) {
                setFunnelName(value);
              }
            }}
            helperText={
              funnelName
                ? `Maximo ${FUNNEL_NAME_MAX_LENGTH} caracteres. ${funnelName.length}/${FUNNEL_NAME_MAX_LENGTH}`
                : "Ejemplo: 'Clientes potenciales'"
            }
          />
        </div>
        {/* 
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name="main-lane"
              checked={isMainLane}
              onChange={() => setIsMainLane(!isMainLane)}
            />
          }
          label="Asignar conversaciones nuevas a esta lista."
          classes={{
            label: classes.label,
          }}
        /> */}

        <CustomButton
          variant="contained"
          onClick={handleSubmit}
          disabled={!funnelName}
          fullWidth
        >
          Crear lista
        </CustomButton>
      </div>
    </CustomModal>
  );
}
